import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Container,
  Paper,
  Chip,
  Stack
} from '@mui/material';
import {
  Dashboard,
  Analytics,
  People,
  Settings,
  Security,
  TrendingUp
} from '@mui/icons-material';

// Import the new admin components
import AdminFinancialDashboard from './AdminFinancialDashboard';
import AdminUserAnalytics from './AdminUserAnalytics';
import AdminPlatformManagement from './AdminPlatformManagement';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const AdminDashboard = (props) => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
          <Dashboard color="primary" sx={{ fontSize: 32 }} />
          <Typography variant="h3" component="h1" color="primary">
            Admin Dashboard
          </Typography>
          <Chip
            label="World-Class Platform"
            color="primary"
            variant="outlined"
            icon={<TrendingUp />}
          />
        </Stack>
        <Typography variant="h6" color="textSecondary">
          Comprehensive platform management and analytics for carbon credit marketplace
        </Typography>
      </Box>

      {/* Navigation Tabs */}
      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab
            icon={<Analytics />}
            label="Financial Dashboard"
            id="admin-tab-0"
            aria-controls="admin-tabpanel-0"
          />
          <Tab
            icon={<People />}
            label="User Analytics"
            id="admin-tab-1"
            aria-controls="admin-tabpanel-1"
          />
          <Tab
            icon={<Settings />}
            label="Platform Management"
            id="admin-tab-2"
            aria-controls="admin-tabpanel-2"
          />
          <Tab
            icon={<Security />}
            label="KYC Applications"
            id="admin-tab-3"
            aria-controls="admin-tabpanel-3"
          />
        </Tabs>
      </Paper>

      {/* Tab Content */}
      <TabPanel value={tabValue} index={0}>
        <AdminFinancialDashboard {...props} />
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <AdminUserAnalytics {...props} />
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <AdminPlatformManagement {...props} />
      </TabPanel>

      <TabPanel value={tabValue} index={3}>
        <AdminPlatformManagement {...props} initialTab={2} />
      </TabPanel>
    </Container>
  );
};

export default AdminDashboard;
